import { useMemo } from 'react';
import { Modal, Text } from '@mantine/core';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';
import 'survey-core/survey-core.css';
import 'survey-creator-core/survey-creator-core.css';
import type { FormContent } from '@/types/formsTemplates';
import styles from './FormPreviewModal.module.sass';

type FormPreviewModalProps = {
  opened: boolean;
  onClose: () => void;
  title: string;
  content: FormContent | null;
};

export const FormPreviewModal = ({ opened, onClose, title, content }: FormPreviewModalProps) => {
  const survey = useMemo(() => {
    if (!content) return null;
    const model = new Model(content);
    model.mode = 'display';
    return model;
  }, [content]);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Text size="xl" fw={600}>
          {title}
        </Text>
      }
      size="xl"
      centered
      classNames={{
        header: styles.modalHeader,
        title: styles.modalTitle,
        close: styles.closeButton,
        body: styles.modalBody,
      }}
    >
      <div className={styles.previewContent}>{survey && <Survey model={survey} />}</div>
    </Modal>
  );
};
